import React from "react";
import { Checkbox } from "primereact/checkbox";
import { RadioButton } from "primereact/radiobutton";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import {Dropdown} from "primereact/dropdown"

function AddOption({
  index,
  addOption,
  question,
  handleOptionChange,
  deleteOption,
  categories,
}) {
  return (
    <React.Fragment>
      {question.questionType === "Range Type" ? (
        <React.Fragment>
          <div className="field col md:col-3 sm:col-12">
            <label htmlFor="option" className="label p-inputgroup">
              Options:{" "}
            </label>

            <InputText
              name="option"
              type="number"
              placeholder="Min"
              value={question.options[0].minRange}
              onChange={(e) => handleOptionChange(e, 0, index)}
              required
            />
          </div>
          <div
            className="field col md:col-3 sm:col-12"
            style={{ marginTop: "2.1rem" }}
          >
            <InputText
              name="option"
              type="number"
              placeholder="Max"
              value={question.options[0].maxRange}
              onChange={(e) => handleOptionChange(e, 1, index)}
              required
            />
          </div>
        </React.Fragment>
      ) : (
        <React.Fragment>
          <div className="field col md:col-3 sm:col-12 p-inputgroup align-items-center">
            {/* <label htmlFor="option" className="label p-inputgroup"> */}
              <span className="label" style={{fontWeight : "bold", fontSize:"0.85rem"}}>Options:</span>
              <Button
                icon="pi pi-plus"
                className="btn-primary plusIcon"
                onClick={(e) => addOption(index)}
                type="button"
              />
            {/* </label> */}
          </div>

          <div className="field col md:col-9 sm:col-12"></div>

          {question.options.map((option, id) => (
            <div className="field col md:col-3 sm:col-12">
              <div
                className="field col md:col-12 sm:col-12"
                key={id}
                style={{ marginTop: "0.1rem" }}
              >
                <div className="p-inputgroup">
                  {question.questionType === "Radio Type" ? (
                    <span className="p-inputgroup-addon">
                      <RadioButton />
                    </span>
                    ) : (
                    <span className="p-inputgroup-addon">
                      <Checkbox />
                    </span>
                  )}

                  <InputText
                    name={`option[${id}]`}
                    type="text"
                    value={option.optionText}
                    onChange={(e) => handleOptionChange(e, id, index)}
                    required
                  />

                {
                  (question.options.length>2) &&
                  <Button
                    onClick={(e) => deleteOption(id, index)}
                    icon="pi pi-trash"
                    className=" p-button-danger"
                    type="button"
                  />
                }
              </div>
            </div>

            <div className="field col md:col-12 sm:col-12">
              <label className="label">
              <span style={{fontWeight:"bold",  fontSize:"0.85rem"}}>* Type</span>
              </label>
              <Dropdown 
                name="category"
                value={option.category}
                onChange={(e) => handleOptionChange(e, id, index)}
                options={categories}
                />
            </div>
            </div>
          ))}
        </React.Fragment>
      )}
    </React.Fragment>
  );
}

export default AddOption;
